import {useEffect,useRef} from 'react';

export function useAnalyticsPolling(callback,interval=60000) {
  const current=useRef(callback);current.current=callback;
  useEffect(() => {
    const run=() => {if (document.visibilityState!=='hidden') current.current();};
    const timer=setInterval(run,interval);
    document.addEventListener('visibilitychange',run);window.addEventListener('focus',run);
    return () => {clearInterval(timer);document.removeEventListener('visibilitychange',run);window.removeEventListener('focus',run);};
  },[interval]);
}

export async function analyticsFetch(url,options={}) {
  const controller=new AbortController();let timedOut=false;
  const abort=() => controller.abort();
  if (options.signal?.aborted) controller.abort();else options.signal?.addEventListener('abort',abort,{once:true});
  const timer=setTimeout(() => {timedOut=true;controller.abort();},25000);
  try {return await globalThis.fetch(url,{...options,signal:controller.signal});}
  catch (error) {if (timedOut) throw new Error('Data refresh timed out. Showing the last successful data; retrying automatically.');throw error;}
  finally {clearTimeout(timer);options.signal?.removeEventListener('abort',abort);}
}
